export const modalPaidTrailPackageSelector = (state: any) =>
  state.OnboardReducer.modalPaidTrailPackage;

export const modalTopPropertiesSelector = (state: any) =>
  state.OnboardReducer.modalTopProperties;
export const packageTrialInfoSelector = (state: any) =>
  state.OnboardReducer.packageTrialInfo;
export const topPropertiesInfoSelector = (state: any) =>
  state.OnboardReducer.topPropertiesInfo;
